import { useQuery } from "react-query";
import { onShowAlerts } from "../presentation/component/popup";
import { useSnackbar } from "./useSnackbar";
import { useAuth } from "./useAuth";
import MainUseCase from "../usecases/MainUseCase";
import MainApi from "../api/MainApi";
import { useEffect } from "react";
import { useLoading } from "./useLoading";

export function useDownload() {
  const { showSnackbar } = useSnackbar();
  const { setExpired } = useAuth();
  const { showLoading } = useLoading();
  const repository = new MainUseCase(new MainApi());
  const {
    data: fileData,
    isFetching: isDownloading,
    refetch: downloadFile,
    isError,
  } = useQuery({
    queryKey: ["downloadFile"],
    queryFn: async () => repository.download(),
    enabled: false, // Fetch only when `downloadFile` is called
    retry: false,
    onSuccess: (results: { data: Blob; filename: string }) => {
      // Create a URL for the blob
      const url = window.URL.createObjectURL(results.data);
      // Create a temporary anchor element to trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = results.filename; // Use the filename from the server
      document.body.appendChild(a);
      a.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    },
    onError: (error: any) => {
      if (
        error.response === undefined ||
        error.response.data === "Read timed out" ||
        error.response.status === 500
      ) {
        showSnackbar("Error - Terjadi Kendala");
      } else if (
        error.response.data !== undefined &&
        error.response.status !== 401
      ) {
        showSnackbar(error.response.data.responseMessage);
      } else if (error.response.status === 401) {
        setExpired(true);
      } else {
        showSnackbar("Error - Terjadi Kendala");
      }
    },
  });

  useEffect(() => {
    showLoading(isDownloading);
  }, [isDownloading]);

  return { downloadFile, isDownloading, isError };
}
